// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.re-page {
  --gold: #f59e0b;
  --gold2: #fbbf24;
  --ink: #0b1020;
  --ink2: #141b33;
  background: var(--bg);
  overflow-x: hidden;
}

.re-cta-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-weight: 800;
  font-size: 0.98rem;
  border-radius: 14px;
  padding: 14px 26px;
  color: #fff;
  background: var(--grad);
  text-decoration: none;
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;
  box-shadow: 0 10px 26px rgba(79, 70, 229, 0.35);
}
.re-cta-btn:hover { transform: translateY(-2px); filter: brightness(1.05); }
.re-cta-gold {
  background: linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%);
  color: #3a2a00;
  box-shadow: 0 12px 30px rgba(245, 158, 11, 0.45);
}
.re-cta-lg { padding: 17px 32px; font-size: 1.05rem; border-radius: 16px; }

.re-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 7px 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: #c7d2fe;
}
.re-badge-gold {
  background: rgba(245, 158, 11, 0.14);
  border-color: rgba(245, 158, 11, 0.4);
  color: #b45309;
}

.re-eye {
  display: block;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--p1);
  margin-bottom: 12px;
}
.re-eye-gold { color: var(--gold); }

.re-h2 {
  font-size: clamp(1.6rem, 3.4vw, 2.5rem);
  font-weight: 800;
  letter-spacing: -0.6px;
  line-height: 1.15;
  color: var(--text);
  margin-bottom: 14px;
}
.re-lead {
  font-size: 1.02rem;
  color: var(--muted);
  line-height: 1.7;
  max-width: 720px;
}

.re-hero {
  position: relative;
  background:
    radial-gradient(1200px 600px at 80% -10%, rgba(129, 140, 248, 0.25), transparent 60%),
    radial-gradient(900px 500px at 0% 0%, rgba(245, 158, 11, 0.12), transparent 55%),
    linear-gradient(160deg, #0b1020 0%, #141b33 100%);
  color: #fff;
  padding: 110px 20px 90px;
}
.re-hero-inner { max-width: 880px; margin: 0 auto; text-align: center; }
.re-hero h1 {
  font-size: clamp(2.1rem, 5.4vw, 3.6rem);
  font-weight: 800;
  letter-spacing: -1px;
  line-height: 1.08;
  margin: 22px 0 18px;
}
.re-grad {
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.re-hero-sub {
  font-size: 1.1rem;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.78);
  max-width: 660px;
  margin: 0 auto;
}
.re-hero-sub strong { color: #fff; }
.re-hero-cta {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  margin-top: 32px;
}
.re-count {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  font-weight: 700;
  color: #fcd34d;
  background: rgba(245, 158, 11, 0.12);
  border: 1px solid rgba(245, 158, 11, 0.3);
  padding: 7px 14px;
  border-radius: 999px;
}
.re-trust {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 18px;
  margin-top: 26px;
}
.re-trust span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.72);
}
.re-trust svg { color: var(--gold2); }

.re-stats {
  background: var(--ink2);
  padding: 4px 20px 0;
}
.re-stats-inner {
  max-width: 1000px;
  margin: -52px auto 0;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 20px 50px rgba(11, 16, 32, 0.18);
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  padding: 30px 20px;
  text-align: center;
}
.re-stat-val {
  font-size: clamp(1.4rem, 3vw, 2rem);
  font-weight: 800;
  color: var(--p1);
  letter-spacing: -0.5px;
}
.re-stat-label { font-size: 0.8rem; color: var(--muted); margin-top: 4px; }
.re-inline-star { display: inline; vertical-align: middle; color: var(--gold); }

.re-section { padding: 72px 20px; }
.re-section-inner { max-width: 1080px; margin: 0 auto; }

.re-pain { background: var(--bg); }
.re-pain-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin: 30px 0 26px;
}
.re-pain-card {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  background: #fff;
  border: 1px solid var(--border);
  border-left: 4px solid #ef4444;
  border-radius: 14px;
  padding: 20px;
}
.re-pain-icon { color: #ef4444; flex-shrink: 0; margin-top: 2px; }
.re-pain-card p { font-size: 0.96rem; color: var(--text); line-height: 1.6; }
.re-pain-foot {
  font-size: 1.05rem;
  color: var(--text);
  line-height: 1.7;
  max-width: 720px;
}
.re-pain-foot strong { color: var(--p1); }

.re-turn { background: var(--surface); }
.re-turn-inner { text-align: center; }
.re-turn .re-lead { margin: 0 auto 28px; }
.re-insight-card {
  display: flex;
  gap: 18px;
  align-items: flex-start;
  text-align: left;
  max-width: 760px;
  margin: 0 auto;
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.08), rgba(251, 191, 36, 0.04));
  border: 1px solid rgba(245, 158, 11, 0.28);
  border-radius: 18px;
  padding: 26px;
}
.re-insight-icon { color: var(--gold); flex-shrink: 0; }
.re-insight-title { font-weight: 800; font-size: 1.1rem; margin-bottom: 6px; color: var(--text); }
.re-insight-card p { color: var(--muted); line-height: 1.7; }
.re-insight-card strong { color: var(--gold); }

.re-benefits { background: var(--bg); }
.re-benefits-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  margin-top: 34px;
}
.re-benefit {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 24px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.re-benefit:hover { transform: translateY(-4px); box-shadow: 0 16px 36px rgba(11, 16, 32, 0.1); }
.re-benefit-icon {
  width: 50px;
  height: 50px;
  border-radius: 14px;
  background: var(--grad);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}
.re-benefit-title { font-weight: 800; font-size: 1.05rem; margin-bottom: 8px; color: var(--text); }
.re-benefit-desc { color: var(--muted); font-size: 0.92rem; line-height: 1.6; }

.re-compare { background: var(--surface); }
.re-compare-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 32px;
}
.re-compare-col {
  border-radius: 18px;
  padding: 26px;
  border: 1px solid var(--border);
}
.re-compare-free { background: var(--bg); }
.re-compare-prem {
  background: linear-gradient(160deg, #0b1020, #1e2547);
  color: #fff;
  border: 1px solid rgba(245, 158, 11, 0.4);
  box-shadow: 0 24px 50px rgba(11, 16, 32, 0.3);
}
.re-compare-head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 800;
  font-size: 1.1rem;
  margin-bottom: 18px;
}
.re-compare-prem .re-compare-head { color: var(--gold2); }
.re-compare-col ul { list-style: none; display: flex; flex-direction: column; gap: 12px; }
.re-compare-col li {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.94rem;
  line-height: 1.4;
}
.re-compare-free li { color: var(--muted); }
.re-compare-free li svg { color: #ef4444; flex-shrink: 0; }
.re-compare-prem li { color: rgba(255, 255, 255, 0.92); }
.re-compare-prem li svg { color: #34d399; flex-shrink: 0; }

.re-testimonials { background: var(--bg); }
.re-testi-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  margin-top: 32px;
}
.re-testi-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 24px;
}
.re-testi-stars { display: flex; gap: 2px; color: var(--gold); margin-bottom: 12px; }
.re-testi-text { font-size: 0.96rem; color: var(--text); line-height: 1.65; margin-bottom: 16px; }
.re-testi-author { display: flex; flex-direction: column; }
.re-testi-author strong { color: var(--text); font-size: 0.95rem; }
.re-testi-author span { color: var(--muted); font-size: 0.82rem; }

.re-offer { padding: 80px 20px; background: var(--surface); }
.re-offer-card {
  max-width: 560px;
  margin: 0 auto;
  background: #fff;
  border: 2px solid rgba(245, 158, 11, 0.4);
  border-radius: 24px;
  padding: 40px 32px;
  text-align: center;
  box-shadow: 0 30px 70px rgba(245, 158, 11, 0.18);
}
.re-offer-card h2 {
  font-size: clamp(1.5rem, 3.4vw, 2.1rem);
  font-weight: 800;
  margin: 18px 0 16px;
  letter-spacing: -0.5px;
}
.re-price { display: flex; align-items: baseline; justify-content: center; gap: 14px; margin-bottom: 10px; }
.re-price-old { color: var(--muted2); text-decoration: line-through; font-size: 1.2rem; font-weight: 700; }
.re-price-now { font-size: 3rem; font-weight: 800; color: var(--gold); line-height: 1; }
.re-price-cents { font-size: 1.8rem; }
.re-price-period { font-size: 1.1rem; color: var(--muted); font-weight: 600; }
.re-offer-sub { color: var(--muted); margin-bottom: 22px; line-height: 1.6; }
.re-offer-list {
  list-style: none;
  text-align: left;
  max-width: 340px;
  margin: 0 auto 26px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.re-offer-list li { display: flex; align-items: center; gap: 10px; font-size: 0.95rem; color: var(--text); }
.re-offer-list svg { color: #10b981; flex-shrink: 0; }
.re-offer .re-count { margin-top: 16px; color: #b45309; background: rgba(245, 158, 11, 0.12); border-color: rgba(245, 158, 11, 0.3); }

.re-faq { background: var(--bg); }
.re-faq-list { max-width: 720px; margin: 30px auto 0; }
.re-faq-item { border-bottom: 1px solid var(--border); }
.re-faq-q {
  width: 100%;
  background: none;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 700;
  color: var(--text);
  text-align: left;
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.re-faq-icon { color: var(--p1); transition: transform 0.2s ease; flex-shrink: 0; }
.re-faq-icon.open { transform: rotate(180deg); }
.re-faq-a { color: var(--muted); font-size: 0.95rem; line-height: 1.7; padding: 0 0 20px; }

.re-final {
  background: linear-gradient(160deg, #0b1020 0%, #1e2547 100%);
  color: #fff;
  padding: 80px 20px;
  text-align: center;
}
.re-final-inner { max-width: 680px; margin: 0 auto; }
.re-final h2 { font-size: clamp(1.7rem, 4vw, 2.6rem); font-weight: 800; letter-spacing: -0.6px; margin-bottom: 14px; }
.re-final p { color: rgba(255, 255, 255, 0.78); font-size: 1.05rem; line-height: 1.7; margin-bottom: 28px; }

.re-modal {
  width: min(640px, 94vw);
  max-height: 92vh;
  margin: auto;
  inset: 0;
  border: none;
  border-radius: 20px;
  padding: 0;
  overflow: hidden;
  box-shadow: 0 30px 80px rgba(11, 16, 32, 0.4);
}
.re-modal::backdrop { background: rgba(11, 16, 32, 0.6); backdrop-filter: blur(4px); }
.re-modal-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px;
  background: linear-gradient(135deg, #0b1020, #1e2547);
  color: #fff;
}
.re-modal-title { font-size: 1.15rem; font-weight: 800; }
.re-modal-sub { font-size: 0.82rem; color: rgba(255, 255, 255, 0.7); margin-top: 4px; }
.re-modal-close {
  background: rgba(255, 255, 255, 0.12);
  border: none;
  color: #fff;
  cursor: pointer;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.re-modal-body { padding: 24px; overflow-y: auto; max-height: calc(92vh - 90px); }
.re-modal-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }

.re-field { display: flex; flex-direction: column; gap: 6px; }
.re-field label { font-size: 0.82rem; font-weight: 600; color: var(--text); }
.re-field input {
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 11px 13px;
  font-size: 0.92rem;
  font-family: inherit;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  width: 100%;
}
.re-field input:focus { border-color: var(--p1); box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12); }
.re-pass-wrap { position: relative; }
.re-pass-eye {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: var(--muted);
  display: flex;
}

.re-cat-search-wrap { position: relative; }
.re-cats-selected { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px; }
.re-cats-list { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px; }
.re-cat-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 7px 12px;
  font-size: 0.82rem;
  font-family: inherit;
  color: var(--text);
  cursor: pointer;
  transition: all 0.15s ease;
}
.re-cat-chip.selected { background: var(--p1); border-color: var(--p1); color: #fff; }
.re-cat-chip button { background: none; border: none; cursor: pointer; color: inherit; display: flex; padding: 0; }

.re-form-note {
  font-size: 0.78rem;
  color: var(--muted2);
  text-align: center;
  margin-top: 12px;
  line-height: 1.5;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.re-steps {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}
.re-step-dot {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--muted2);
  padding: 6px 12px;
  border-radius: 999px;
  background: var(--bg);
  border: 1px solid var(--border);
  white-space: nowrap;
}
.re-step-dot.active { color: #fff; background: var(--p1); border-color: var(--p1); }
.re-step-line { flex: 1 1; height: 1px; background: var(--border); }

.re-pay-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.08), rgba(251, 191, 36, 0.04));
  border: 1px solid rgba(245, 158, 11, 0.3);
  border-radius: 14px;
  padding: 16px 18px;
}
.re-pay-plan { display: flex; align-items: center; gap: 7px; font-weight: 800; color: var(--text); }
.re-pay-plan svg { color: var(--gold); }
.re-pay-desc { font-size: 0.8rem; color: var(--muted); margin-top: 4px; }
.re-pay-price { font-size: 1.5rem; font-weight: 800; color: var(--gold); white-space: nowrap; }
.re-pay-price span { font-size: 0.85rem; color: var(--muted); font-weight: 600; }

.re-field label svg { vertical-align: middle; margin-right: 4px; }
.re-card-box {
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 14px 13px;
  background: #fff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.re-card-box:focus-within { border-color: var(--p1); box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12); }

.re-back-btn {
  width: 100%;
  background: none;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--muted);
  padding: 12px;
  margin-top: 6px;
}
.re-back-btn:hover { color: var(--text); }

.re-alert {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 0.88rem;
  margin-bottom: 16px;
}
.re-alert-err { background: #fef2f2; color: #b91c1c; border: 1px solid #fecaca; }

.re-success { text-align: center; padding: 14px 4px; }
.re-success-icon {
  width: 76px;
  height: 76px;
  border-radius: 50%;
  background: #d1fae5;
  color: #059669;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}
.re-success h3 { font-size: 1.3rem; font-weight: 800; margin-bottom: 10px; color: var(--text); }
.re-success p { color: var(--muted); line-height: 1.7; max-width: 420px; margin: 0 auto 18px; }
.re-success strong { color: var(--gold); }
.re-store-row { display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; }
.re-store-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--ink);
  color: #fff;
  text-decoration: none;
  padding: 11px 18px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 0.9rem;
}

@media (max-width: 860px) {
  .re-stats-inner { grid-template-columns: repeat(2, 1fr); gap: 20px; }
  .re-benefits-grid, .re-testi-grid { grid-template-columns: 1fr; }
  .re-pain-grid, .re-compare-grid { grid-template-columns: 1fr; }
  .re-modal-grid { grid-template-columns: 1fr; }
  .re-hero { padding: 90px 20px 80px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/RendaExtra.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,0EAA0E;EAC1E,+CAA+C;AACjD;AACA,oBAAoB,2BAA2B,EAAE,wBAAwB,EAAE;AAC3E;EACE,6DAA6D;EAC7D,cAAc;EACd,gDAAgD;AAClD;AACA,aAAa,kBAAkB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;;AAE1E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,eAAe,kBAAkB,EAAE;;AAEnC;EACE,uCAAuC;EACvC,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB;;;qDAGmD;EACnD,WAAW;EACX,wBAAwB;AAC1B;AACA,iBAAiB,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACvE;EACE,uCAAuC;EACvC,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;AACA,sBAAsB,WAAW,EAAE;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,yCAAyC;EACzC,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;AAClC;AACA,gBAAgB,mBAAmB,EAAE;;AAErC;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;AACA,iBAAiB,iBAAiB,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAC1E,kBAAkB,eAAe,EAAE,sBAAsB,EAAE,kBAAkB,EAAE;;AAE/E,cAAc,kBAAkB,EAAE;AAClC,oBAAoB,iBAAiB,EAAE,cAAc,EAAE;;AAEvD,WAAW,qBAAqB,EAAE;AAClC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;AACA,gBAAgB,cAAc,EAAE,cAAc,EAAE,eAAe,EAAE;AACjE,kBAAkB,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC5E;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA,uBAAuB,gBAAgB,EAAE;;AAEzC,WAAW,0BAA0B,EAAE;AACvC,iBAAiB,kBAAkB,EAAE;AACrC,oBAAoB,mBAAmB,EAAE;AACzC;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,uFAAuF;EACvF,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;AACf;AACA,mBAAmB,kBAAkB,EAAE,cAAc,EAAE;AACvD,oBAAoB,gBAAgB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AACjG,qBAAqB,mBAAmB,EAAE,gBAAgB,EAAE;AAC5D,0BAA0B,kBAAkB,EAAE;;AAE9C,eAAe,qBAAqB,EAAE;AACtC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,qDAAqD;AACvD;AACA,oBAAoB,2BAA2B,EAAE,6CAA6C,EAAE;AAChG;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,oBAAoB,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAClG,mBAAmB,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAE9E,cAAc,0BAA0B,EAAE;AAC1C;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;AACA,mBAAmB,qBAAqB,EAAE;AAC1C;EACE,qDAAqD;EACrD,WAAW;EACX,yCAAyC;EACzC,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA,oCAAoC,mBAAmB,EAAE;AACzD,qBAAqB,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACzF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;AACA,sBAAsB,mBAAmB,EAAE;AAC3C,0BAA0B,cAAc,EAAE,cAAc,EAAE;AAC1D,sBAAsB,gCAAgC,EAAE;AACxD,0BAA0B,cAAc,EAAE,cAAc,EAAE;;AAE1D,mBAAmB,qBAAqB,EAAE;AAC1C;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;AACf;AACA,kBAAkB,aAAa,EAAE,QAAQ,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AACpF,iBAAiB,kBAAkB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;AACjG,mBAAmB,aAAa,EAAE,sBAAsB,EAAE;AAC1D,0BAA0B,kBAAkB,EAAE,kBAAkB,EAAE;AAClE,wBAAwB,mBAAmB,EAAE,kBAAkB,EAAE;;AAEjE,YAAY,kBAAkB,EAAE,0BAA0B,EAAE;AAC5D;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gDAAgD;AAClD;AACA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;AACA,YAAY,aAAa,EAAE,qBAAqB,EAAE,uBAAuB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAC3G,gBAAgB,oBAAoB,EAAE,6BAA6B,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC1G,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,cAAc,EAAE;AACvF,kBAAkB,iBAAiB,EAAE;AACrC,mBAAmB,iBAAiB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAC7E,gBAAgB,mBAAmB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAC5E;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAC3G,qBAAqB,cAAc,EAAE,cAAc,EAAE;AACrD,sBAAsB,gBAAgB,EAAE,cAAc,EAAE,oCAAoC,EAAE,qCAAqC,EAAE;;AAErI,UAAU,qBAAqB,EAAE;AACjC,eAAe,gBAAgB,EAAE,mBAAmB,EAAE;AACtD,eAAe,sCAAsC,EAAE;AACvD;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA,eAAe,gBAAgB,EAAE,+BAA+B,EAAE,cAAc,EAAE;AAClF,oBAAoB,yBAAyB,EAAE;AAC/C,YAAY,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAE1F;EACE,6DAA6D;EAC7D,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;AACA,kBAAkB,gBAAgB,EAAE,cAAc,EAAE;AACpD,eAAe,qCAAqC,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;AACrH,cAAc,gCAAgC,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAE3G;EACE,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,6CAA6C;AAC/C;AACA,sBAAsB,iCAAiC,EAAE,0BAA0B,EAAE;AACrF;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;AACb;AACA,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE;AACxD,gBAAgB,kBAAkB,EAAE,+BAA+B,EAAE,eAAe,EAAE;AACtF;EACE,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,iBAAiB,aAAa,EAAE,gBAAgB,EAAE,6BAA6B,EAAE;AACjF,iBAAiB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE;;AAE3E,YAAY,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC7D,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC5E;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,0DAA0D;EAC1D,WAAW;AACb;AACA,wBAAwB,uBAAuB,EAAE,6CAA6C,EAAE;AAChG,gBAAgB,kBAAkB,EAAE;AACpC;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA,sBAAsB,kBAAkB,EAAE;AAC1C,oBAAoB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAChF,gBAAgB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAC5E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,+BAA+B;EAC/B,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;AACA,wBAAwB,qBAAqB,EAAE,uBAAuB,EAAE,WAAW,EAAE;AACrF,sBAAsB,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,cAAc,EAAE,aAAa,EAAE,UAAU,EAAE;;AAElH;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;AACrB;AACA,sBAAsB,WAAW,EAAE,qBAAqB,EAAE,uBAAuB,EAAE;AACnF,gBAAgB,SAAO,EAAE,WAAW,EAAE,yBAAyB,EAAE;;AAEjE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uFAAuF;EACvF,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;AACpB;AACA,eAAe,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACnG,mBAAmB,kBAAkB,EAAE;AACvC,eAAe,iBAAiB,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACxE,gBAAgB,iBAAiB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AAC9F,qBAAqB,kBAAkB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAEhF,sBAAsB,sBAAsB,EAAE,iBAAiB,EAAE;AACjE;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0DAA0D;AAC5D;AACA,4BAA4B,uBAAuB,EAAE,6CAA6C,EAAE;;AAEpG;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;AACA,qBAAqB,kBAAkB,EAAE;;AAEzC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA,gBAAgB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAEhF,cAAc,kBAAkB,EAAE,iBAAiB,EAAE;AACrD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AAC/F,gBAAgB,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC9F,qBAAqB,kBAAkB,EAAE;AACzC,gBAAgB,aAAa,EAAE,SAAS,EAAE,uBAAuB,EAAE,eAAe,EAAE;AACpF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB,qCAAqC,EAAE,SAAS,EAAE;EACpE,oCAAoC,0BAA0B,EAAE;EAChE,kCAAkC,0BAA0B,EAAE;EAC9D,iBAAiB,0BAA0B,EAAE;EAC7C,WAAW,uBAAuB,EAAE;AACtC","sourcesContent":[".re-page {\n  --gold: #f59e0b;\n  --gold2: #fbbf24;\n  --ink: #0b1020;\n  --ink2: #141b33;\n  background: var(--bg);\n  overflow-x: hidden;\n}\n\n.re-cta-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: none;\n  cursor: pointer;\n  font-family: inherit;\n  font-weight: 800;\n  font-size: 0.98rem;\n  border-radius: 14px;\n  padding: 14px 26px;\n  color: #fff;\n  background: var(--grad);\n  text-decoration: none;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;\n  box-shadow: 0 10px 26px rgba(79, 70, 229, 0.35);\n}\n.re-cta-btn:hover { transform: translateY(-2px); filter: brightness(1.05); }\n.re-cta-gold {\n  background: linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%);\n  color: #3a2a00;\n  box-shadow: 0 12px 30px rgba(245, 158, 11, 0.45);\n}\n.re-cta-lg { padding: 17px 32px; font-size: 1.05rem; border-radius: 16px; }\n\n.re-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.74rem;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  padding: 7px 14px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  color: #c7d2fe;\n}\n.re-badge-gold {\n  background: rgba(245, 158, 11, 0.14);\n  border-color: rgba(245, 158, 11, 0.4);\n  color: #b45309;\n}\n\n.re-eye {\n  display: block;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  color: var(--p1);\n  margin-bottom: 12px;\n}\n.re-eye-gold { color: var(--gold); }\n\n.re-h2 {\n  font-size: clamp(1.6rem, 3.4vw, 2.5rem);\n  font-weight: 800;\n  letter-spacing: -0.6px;\n  line-height: 1.15;\n  color: var(--text);\n  margin-bottom: 14px;\n}\n.re-lead {\n  font-size: 1.02rem;\n  color: var(--muted);\n  line-height: 1.7;\n  max-width: 720px;\n}\n\n.re-hero {\n  position: relative;\n  background:\n    radial-gradient(1200px 600px at 80% -10%, rgba(129, 140, 248, 0.25), transparent 60%),\n    radial-gradient(900px 500px at 0% 0%, rgba(245, 158, 11, 0.12), transparent 55%),\n    linear-gradient(160deg, #0b1020 0%, #141b33 100%);\n  color: #fff;\n  padding: 110px 20px 90px;\n}\n.re-hero-inner { max-width: 880px; margin: 0 auto; text-align: center; }\n.re-hero h1 {\n  font-size: clamp(2.1rem, 5.4vw, 3.6rem);\n  font-weight: 800;\n  letter-spacing: -1px;\n  line-height: 1.08;\n  margin: 22px 0 18px;\n}\n.re-grad {\n  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n.re-hero-sub {\n  font-size: 1.1rem;\n  line-height: 1.7;\n  color: rgba(255, 255, 255, 0.78);\n  max-width: 660px;\n  margin: 0 auto;\n}\n.re-hero-sub strong { color: #fff; }\n.re-hero-cta {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  margin-top: 32px;\n}\n.re-count {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: #fcd34d;\n  background: rgba(245, 158, 11, 0.12);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  padding: 7px 14px;\n  border-radius: 999px;\n}\n.re-trust {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 18px;\n  margin-top: 26px;\n}\n.re-trust span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.85rem;\n  color: rgba(255, 255, 255, 0.72);\n}\n.re-trust svg { color: var(--gold2); }\n\n.re-stats {\n  background: var(--ink2);\n  padding: 4px 20px 0;\n}\n.re-stats-inner {\n  max-width: 1000px;\n  margin: -52px auto 0;\n  background: #fff;\n  border-radius: 20px;\n  box-shadow: 0 20px 50px rgba(11, 16, 32, 0.18);\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 10px;\n  padding: 30px 20px;\n  text-align: center;\n}\n.re-stat-val {\n  font-size: clamp(1.4rem, 3vw, 2rem);\n  font-weight: 800;\n  color: var(--p1);\n  letter-spacing: -0.5px;\n}\n.re-stat-label { font-size: 0.8rem; color: var(--muted); margin-top: 4px; }\n.re-inline-star { display: inline; vertical-align: middle; color: var(--gold); }\n\n.re-section { padding: 72px 20px; }\n.re-section-inner { max-width: 1080px; margin: 0 auto; }\n\n.re-pain { background: var(--bg); }\n.re-pain-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  margin: 30px 0 26px;\n}\n.re-pain-card {\n  display: flex;\n  gap: 14px;\n  align-items: flex-start;\n  background: #fff;\n  border: 1px solid var(--border);\n  border-left: 4px solid #ef4444;\n  border-radius: 14px;\n  padding: 20px;\n}\n.re-pain-icon { color: #ef4444; flex-shrink: 0; margin-top: 2px; }\n.re-pain-card p { font-size: 0.96rem; color: var(--text); line-height: 1.6; }\n.re-pain-foot {\n  font-size: 1.05rem;\n  color: var(--text);\n  line-height: 1.7;\n  max-width: 720px;\n}\n.re-pain-foot strong { color: var(--p1); }\n\n.re-turn { background: var(--surface); }\n.re-turn-inner { text-align: center; }\n.re-turn .re-lead { margin: 0 auto 28px; }\n.re-insight-card {\n  display: flex;\n  gap: 18px;\n  align-items: flex-start;\n  text-align: left;\n  max-width: 760px;\n  margin: 0 auto;\n  background: linear-gradient(135deg, rgba(245, 158, 11, 0.08), rgba(251, 191, 36, 0.04));\n  border: 1px solid rgba(245, 158, 11, 0.28);\n  border-radius: 18px;\n  padding: 26px;\n}\n.re-insight-icon { color: var(--gold); flex-shrink: 0; }\n.re-insight-title { font-weight: 800; font-size: 1.1rem; margin-bottom: 6px; color: var(--text); }\n.re-insight-card p { color: var(--muted); line-height: 1.7; }\n.re-insight-card strong { color: var(--gold); }\n\n.re-benefits { background: var(--bg); }\n.re-benefits-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 18px;\n  margin-top: 34px;\n}\n.re-benefit {\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  padding: 24px;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n.re-benefit:hover { transform: translateY(-4px); box-shadow: 0 16px 36px rgba(11, 16, 32, 0.1); }\n.re-benefit-icon {\n  width: 50px;\n  height: 50px;\n  border-radius: 14px;\n  background: var(--grad);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n.re-benefit-title { font-weight: 800; font-size: 1.05rem; margin-bottom: 8px; color: var(--text); }\n.re-benefit-desc { color: var(--muted); font-size: 0.92rem; line-height: 1.6; }\n\n.re-compare { background: var(--surface); }\n.re-compare-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-top: 32px;\n}\n.re-compare-col {\n  border-radius: 18px;\n  padding: 26px;\n  border: 1px solid var(--border);\n}\n.re-compare-free { background: var(--bg); }\n.re-compare-prem {\n  background: linear-gradient(160deg, #0b1020, #1e2547);\n  color: #fff;\n  border: 1px solid rgba(245, 158, 11, 0.4);\n  box-shadow: 0 24px 50px rgba(11, 16, 32, 0.3);\n}\n.re-compare-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 800;\n  font-size: 1.1rem;\n  margin-bottom: 18px;\n}\n.re-compare-prem .re-compare-head { color: var(--gold2); }\n.re-compare-col ul { list-style: none; display: flex; flex-direction: column; gap: 12px; }\n.re-compare-col li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.94rem;\n  line-height: 1.4;\n}\n.re-compare-free li { color: var(--muted); }\n.re-compare-free li svg { color: #ef4444; flex-shrink: 0; }\n.re-compare-prem li { color: rgba(255, 255, 255, 0.92); }\n.re-compare-prem li svg { color: #34d399; flex-shrink: 0; }\n\n.re-testimonials { background: var(--bg); }\n.re-testi-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 18px;\n  margin-top: 32px;\n}\n.re-testi-card {\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  padding: 24px;\n}\n.re-testi-stars { display: flex; gap: 2px; color: var(--gold); margin-bottom: 12px; }\n.re-testi-text { font-size: 0.96rem; color: var(--text); line-height: 1.65; margin-bottom: 16px; }\n.re-testi-author { display: flex; flex-direction: column; }\n.re-testi-author strong { color: var(--text); font-size: 0.95rem; }\n.re-testi-author span { color: var(--muted); font-size: 0.82rem; }\n\n.re-offer { padding: 80px 20px; background: var(--surface); }\n.re-offer-card {\n  max-width: 560px;\n  margin: 0 auto;\n  background: #fff;\n  border: 2px solid rgba(245, 158, 11, 0.4);\n  border-radius: 24px;\n  padding: 40px 32px;\n  text-align: center;\n  box-shadow: 0 30px 70px rgba(245, 158, 11, 0.18);\n}\n.re-offer-card h2 {\n  font-size: clamp(1.5rem, 3.4vw, 2.1rem);\n  font-weight: 800;\n  margin: 18px 0 16px;\n  letter-spacing: -0.5px;\n}\n.re-price { display: flex; align-items: baseline; justify-content: center; gap: 14px; margin-bottom: 10px; }\n.re-price-old { color: var(--muted2); text-decoration: line-through; font-size: 1.2rem; font-weight: 700; }\n.re-price-now { font-size: 3rem; font-weight: 800; color: var(--gold); line-height: 1; }\n.re-price-cents { font-size: 1.8rem; }\n.re-price-period { font-size: 1.1rem; color: var(--muted); font-weight: 600; }\n.re-offer-sub { color: var(--muted); margin-bottom: 22px; line-height: 1.6; }\n.re-offer-list {\n  list-style: none;\n  text-align: left;\n  max-width: 340px;\n  margin: 0 auto 26px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.re-offer-list li { display: flex; align-items: center; gap: 10px; font-size: 0.95rem; color: var(--text); }\n.re-offer-list svg { color: #10b981; flex-shrink: 0; }\n.re-offer .re-count { margin-top: 16px; color: #b45309; background: rgba(245, 158, 11, 0.12); border-color: rgba(245, 158, 11, 0.3); }\n\n.re-faq { background: var(--bg); }\n.re-faq-list { max-width: 720px; margin: 30px auto 0; }\n.re-faq-item { border-bottom: 1px solid var(--border); }\n.re-faq-q {\n  width: 100%;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text);\n  text-align: left;\n  padding: 20px 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n.re-faq-icon { color: var(--p1); transition: transform 0.2s ease; flex-shrink: 0; }\n.re-faq-icon.open { transform: rotate(180deg); }\n.re-faq-a { color: var(--muted); font-size: 0.95rem; line-height: 1.7; padding: 0 0 20px; }\n\n.re-final {\n  background: linear-gradient(160deg, #0b1020 0%, #1e2547 100%);\n  color: #fff;\n  padding: 80px 20px;\n  text-align: center;\n}\n.re-final-inner { max-width: 680px; margin: 0 auto; }\n.re-final h2 { font-size: clamp(1.7rem, 4vw, 2.6rem); font-weight: 800; letter-spacing: -0.6px; margin-bottom: 14px; }\n.re-final p { color: rgba(255, 255, 255, 0.78); font-size: 1.05rem; line-height: 1.7; margin-bottom: 28px; }\n\n.re-modal {\n  width: min(640px, 94vw);\n  max-height: 92vh;\n  margin: auto;\n  inset: 0;\n  border: none;\n  border-radius: 20px;\n  padding: 0;\n  overflow: hidden;\n  box-shadow: 0 30px 80px rgba(11, 16, 32, 0.4);\n}\n.re-modal::backdrop { background: rgba(11, 16, 32, 0.6); backdrop-filter: blur(4px); }\n.re-modal-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 22px 24px;\n  background: linear-gradient(135deg, #0b1020, #1e2547);\n  color: #fff;\n}\n.re-modal-title { font-size: 1.15rem; font-weight: 800; }\n.re-modal-sub { font-size: 0.82rem; color: rgba(255, 255, 255, 0.7); margin-top: 4px; }\n.re-modal-close {\n  background: rgba(255, 255, 255, 0.12);\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.re-modal-body { padding: 24px; overflow-y: auto; max-height: calc(92vh - 90px); }\n.re-modal-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }\n\n.re-field { display: flex; flex-direction: column; gap: 6px; }\n.re-field label { font-size: 0.82rem; font-weight: 600; color: var(--text); }\n.re-field input {\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 11px 13px;\n  font-size: 0.92rem;\n  font-family: inherit;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  width: 100%;\n}\n.re-field input:focus { border-color: var(--p1); box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12); }\n.re-pass-wrap { position: relative; }\n.re-pass-eye {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--muted);\n  display: flex;\n}\n\n.re-cat-search-wrap { position: relative; }\n.re-cats-selected { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px; }\n.re-cats-list { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px; }\n.re-cat-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  padding: 7px 12px;\n  font-size: 0.82rem;\n  font-family: inherit;\n  color: var(--text);\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n.re-cat-chip.selected { background: var(--p1); border-color: var(--p1); color: #fff; }\n.re-cat-chip button { background: none; border: none; cursor: pointer; color: inherit; display: flex; padding: 0; }\n\n.re-form-note {\n  font-size: 0.78rem;\n  color: var(--muted2);\n  text-align: center;\n  margin-top: 12px;\n  line-height: 1.5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.re-steps {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n.re-step-dot {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--muted2);\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: var(--bg);\n  border: 1px solid var(--border);\n  white-space: nowrap;\n}\n.re-step-dot.active { color: #fff; background: var(--p1); border-color: var(--p1); }\n.re-step-line { flex: 1; height: 1px; background: var(--border); }\n\n.re-pay-summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  background: linear-gradient(135deg, rgba(245, 158, 11, 0.08), rgba(251, 191, 36, 0.04));\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  border-radius: 14px;\n  padding: 16px 18px;\n}\n.re-pay-plan { display: flex; align-items: center; gap: 7px; font-weight: 800; color: var(--text); }\n.re-pay-plan svg { color: var(--gold); }\n.re-pay-desc { font-size: 0.8rem; color: var(--muted); margin-top: 4px; }\n.re-pay-price { font-size: 1.5rem; font-weight: 800; color: var(--gold); white-space: nowrap; }\n.re-pay-price span { font-size: 0.85rem; color: var(--muted); font-weight: 600; }\n\n.re-field label svg { vertical-align: middle; margin-right: 4px; }\n.re-card-box {\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 14px 13px;\n  background: #fff;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.re-card-box:focus-within { border-color: var(--p1); box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12); }\n\n.re-back-btn {\n  width: 100%;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--muted);\n  padding: 12px;\n  margin-top: 6px;\n}\n.re-back-btn:hover { color: var(--text); }\n\n.re-alert {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 10px;\n  padding: 12px 14px;\n  font-size: 0.88rem;\n  margin-bottom: 16px;\n}\n.re-alert-err { background: #fef2f2; color: #b91c1c; border: 1px solid #fecaca; }\n\n.re-success { text-align: center; padding: 14px 4px; }\n.re-success-icon {\n  width: 76px;\n  height: 76px;\n  border-radius: 50%;\n  background: #d1fae5;\n  color: #059669;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 16px;\n}\n.re-success h3 { font-size: 1.3rem; font-weight: 800; margin-bottom: 10px; color: var(--text); }\n.re-success p { color: var(--muted); line-height: 1.7; max-width: 420px; margin: 0 auto 18px; }\n.re-success strong { color: var(--gold); }\n.re-store-row { display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; }\n.re-store-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--ink);\n  color: #fff;\n  text-decoration: none;\n  padding: 11px 18px;\n  border-radius: 12px;\n  font-weight: 700;\n  font-size: 0.9rem;\n}\n\n@media (max-width: 860px) {\n  .re-stats-inner { grid-template-columns: repeat(2, 1fr); gap: 20px; }\n  .re-benefits-grid, .re-testi-grid { grid-template-columns: 1fr; }\n  .re-pain-grid, .re-compare-grid { grid-template-columns: 1fr; }\n  .re-modal-grid { grid-template-columns: 1fr; }\n  .re-hero { padding: 90px 20px 80px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
